// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "blocks-wrapper-client-stories-" + "jquery-touchswipe" + ".production.bundle.min.js";
};